
export const EditScripts = ({ section, onUpdated, style = {} }) => {

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      Edit Scripts
    </div>
  )
}

export default EditScripts;
